import styled, { keyframes } from 'styled-components';

// Implementacao do design Usuarios.html (handoff bundle) — segue
// o "hairline shell" pattern: page-header + filters 5-col grid +
// table 8-col grid + pager. Todas as cores via CSS vars (--cco-*).
// Compat: exports antigos (Card, Wrapper, ButtonCliente, PaginationContainer,
// Label, IconNew, LabelCadastro, ButtonDiv) sao mantidos no final pra
// nao quebrar outros lugares que ainda referenciam.

// ============================================================
// Container
// ============================================================
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100vw - 64px);
  min-height: 100vh;
  margin: 0 0 0 64px;
  padding: 0;
  box-sizing: border-box;
  background: var(--cco-bg);
  color: var(--cco-ink);

  @media (max-width: 720px) {
    width: 100vw;
    margin: 0;
  }
`;

// ============================================================
// Page Header (.ph) — titulo + sub + contador
// ============================================================
export const PageHeader = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 18px var(--cco-pad);
  border-bottom: 1px solid var(--cco-line);

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const PageHeaderText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--cco-ink);
`;

export const PageSub = styled.div`
  color: var(--cco-ink-mute);
  font-size: 13px;
  margin-top: 3px;
`;

export const PageCount = styled.div`
  font-size: 13px;
  color: var(--cco-ink-mute);
  font-variant-numeric: tabular-nums;

  b {
    color: var(--cco-ink);
    font-weight: 700;
  }
`;

// ============================================================
// Filters (.filters) — 5 cols: busca | cliente | acesso | status | CTA
// ============================================================
export const Filters = styled.section`
  display: grid;
  grid-template-columns: 1fr 200px 200px 200px auto;
  border-bottom: 1px solid var(--cco-line);

  > * + * {
    border-left: 1px solid var(--cco-line);
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr;
    > * + * {
      border-left: 0;
    }
    > *:not(:nth-child(3n)) {
      border-right: 1px solid var(--cco-line);
    }
    > *:not(:nth-child(-n + 3)) {
      border-top: 1px solid var(--cco-line);
    }
    > .cta {
      grid-column: 1 / -1;
    }
  }

  /* Mobile: tudo empilhado em 1 coluna, hairlines viram bottom-borders */
  @media (max-width: 720px) {
    grid-template-columns: 1fr;
    > * {
      border: 0 !important;
      border-bottom: 1px solid var(--cco-line) !important;
    }
    > *:last-child {
      border-bottom: 0 !important;
    }
  }
`;

export const Search = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px var(--cco-pad);

  svg {
    color: var(--cco-ink-mute);
    flex: none;
    width: 16px;
    height: 16px;
  }

  input {
    flex: 1;
    background: transparent;
    border: 0;
    outline: 0;
    color: var(--cco-ink);
    font: inherit;
    font-size: 14px;
    padding: 8px 0;
    min-width: 0;

    ::placeholder {
      color: var(--cco-ink-faint);
    }
  }
`;

export const SelCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px var(--cco-pad);

  .k {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--cco-ink-mute);
    flex: none;
  }

  select {
    flex: 1;
    background: transparent;
    border: 0;
    outline: 0;
    color: var(--cco-ink);
    font: inherit;
    font-size: 13.5px;
    font-weight: 500;
    padding: 8px 22px 8px 0;
    appearance: none;
    cursor: pointer;
    width: 100%;
    min-width: 0;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'><path fill='rgba(255,255,255,.4)' d='M0 0h12L6 8z'/></svg>");
    background-repeat: no-repeat;
    background-position: right 0 center;
  }

  select:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  select option {
    background: var(--cco-bg);
    color: var(--cco-ink);
  }
`;

// CTA pill cyan-soft
export const Cta = styled.button.attrs({ className: 'cta' })`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: rgba(28, 176, 216, 0.1);
  color: var(--cco-cyan);
  border: 0;
  transition: background 150ms ease;
  cursor: pointer;
  min-width: 230px;
  font-family: inherit;

  @media (max-width: 720px) {
    min-width: 0;
    width: 100%;
    justify-content: flex-start;
  }

  :hover {
    background: rgba(28, 176, 216, 0.18);
  }

  .ic {
    width: 34px;
    height: 34px;
    border-radius: 9px;
    background: var(--cco-cyan);
    color: #0a0a0b;
    display: grid;
    place-items: center;
    flex: none;

    svg {
      width: 18px;
      height: 18px;
    }
  }

  .tx {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.25;
  }
  .tx .t {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
  .tx .s {
    font-size: 11.5px;
    color: var(--cco-ink-mute);
    font-weight: 500;
  }
`;

// ============================================================
// Table (.table) — 9 cols: Editar | Usuario | Empresa | Email | Acesso |
// Ultimo acesso | Status | Ativacao | Excluir
// ============================================================
export const TableWrap = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const Table = styled.div`
  display: grid;
  grid-template-columns: 90px 1.2fr 0.9fr 1.4fr 1fr 145px 110px 100px 80px;
  align-items: stretch;

  /* Mobile: vira card layout (cada Tr empilha, Th some). */
  @media (max-width: 720px) {
    display: flex;
    flex-direction: column;
  }
`;

export const Th = styled.div`
  padding: 14px var(--cco-pad);
  color: var(--cco-ink-mute);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  border-bottom: 1px solid var(--cco-line);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 720px) {
    display: none;
  }
`;

// Tr — display:contents pra cada filho cair direto no grid pai
export const Tr = styled.div`
  display: contents;

  :hover .tc {
    background: rgba(255, 255, 255, 0.02);
  }

  @media (max-width: 720px) {
    display: flex;
    flex-direction: column;
    padding: 14px var(--cco-pad);
    border-bottom: 1px solid var(--cco-line);
    gap: 4px;
  }
`;

export const Tc = styled.div.attrs({ className: 'tc' })`
  padding: 16px var(--cco-pad);
  border-bottom: 1px solid var(--cco-line);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 120ms ease;
  min-width: 0;
  gap: 8px;

  @media (max-width: 720px) {
    padding: 4px 0;
    border-bottom: 0;
    justify-content: flex-start;
    &::before {
      content: attr(data-label);
      color: var(--cco-ink-mute);
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 0.14em;
      text-transform: uppercase;
      margin-right: 8px;
      min-width: 70px;
      flex-shrink: 0;
    }
  }
`;

export const TcNome = styled(Tc).attrs({ 'data-label': 'Usuário' })`
  font-weight: 700;
  color: var(--cco-ink);
  font-size: 14px;
`;

export const TcEmpresa = styled(Tc).attrs({ 'data-label': 'Empresa' })`
  font-weight: 600;
  color: var(--cco-ink);
  font-size: 13.5px;
  letter-spacing: 0.02em;
`;

export const TcEmail = styled(Tc).attrs({ 'data-label': 'E-mail' })`
  color: var(--cco-ink);
  font-size: 13px;
  font-variant-numeric: tabular-nums;
`;

export const TcLastAccess = styled(Tc).attrs({ 'data-label': 'Último acesso' })`
  color: var(--cco-ink-mute);
  font-size: 12.5px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

// Row select (.row-select) — pill com border, usado pra acesso/role
export const RowSelect = styled.select`
  width: 100%;
  max-width: 160px;
  height: 36px;
  padding: 0 30px 0 14px;
  background: transparent;
  border: 1px solid var(--cco-line-strong);
  border-radius: 999px;
  color: var(--cco-ink);
  font-size: 13px;
  font-family: inherit;
  appearance: none;
  cursor: pointer;
  outline: none;
  transition: border-color 150ms ease, background 150ms ease;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(255,255,255,.5)' d='M0 0h10L5 6z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 12px center;

  :hover:not(:disabled) {
    background-color: rgba(255, 255, 255, 0.04);
  }
  :focus {
    border-color: var(--cco-cyan);
  }
  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  option {
    background: var(--cco-bg);
    color: var(--cco-ink);
  }
`;

// Status pill com bolinha (.status) — Ativo verde / Inativo cinza
export const StatusDot = styled.span`
  color: ${(p) => (p.$on ? 'var(--cco-green)' : 'var(--cco-ink-mute)')};
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  ::before {
    content: '';
    width: 7px;
    height: 7px;
    border-radius: 999px;
    background: ${(p) =>
      p.$on ? 'var(--cco-green)' : 'var(--cco-gray, #5a6068)'};
    box-shadow: 0 0 0 3px
      ${(p) => (p.$on ? 'rgba(43,212,125,.18)' : 'rgba(90,96,104,.18)')};
  }
`;

// Toggle iOS-style 42x22
export const Toggle = styled.button`
  width: 42px;
  height: 22px;
  border-radius: 999px;
  background: ${(p) => (p.$on ? 'var(--cco-green)' : 'rgba(255,255,255,.1)')};
  border: 0;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.3);
  position: relative;
  transition: background 150ms ease;
  cursor: pointer;
  padding: 0;
  flex: none;
  font-family: inherit;

  ::after {
    content: '';
    position: absolute;
    top: 2px;
    left: ${(p) => (p.$on ? '22px' : '2px')};
    width: 18px;
    height: 18px;
    border-radius: 999px;
    background: #fff;
    transition: left 150ms ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  }

  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// Icon btn (.icon-btn) — 36x32 com border, hover cyan / red
export const IconBtn = styled.button`
  width: 36px;
  height: 32px;
  /* Touch target >=44px no mobile (WCAG 2.5.5 / Apple HIG). */
  @media (max-width: 720px) {
    min-width: 44px;
    min-height: 44px;
  }
  border-radius: 8px;
  background: transparent;
  border: 1px solid var(--cco-line-strong);
  display: grid;
  place-items: center;
  color: var(--cco-ink-mute);
  transition: all 150ms ease;
  cursor: pointer;
  font-family: inherit;

  :hover:not(:disabled) {
    color: var(--cco-cyan);
    border-color: var(--cco-cyan);
  }

  &.danger:hover:not(:disabled) {
    color: var(--cco-red);
    border-color: var(--cco-red);
    background: var(--cco-red-soft, rgba(244, 68, 92, 0.14));
  }

  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// Empty row (full-width)
export const EmptyRow = styled.div`
  grid-column: 1 / -1;
  padding: 60px 0;
  text-align: center;
  color: var(--cco-ink-faint);
`;

// Skeleton row pra loading
const shimmer = keyframes`
  0%   { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

export const SkeletonCell = styled(Tc)`
  ::before {
    content: '';
    display: block;
    width: ${(props) => props.$w || '70%'};
    height: 14px;
    border-radius: 6px;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.04) 0%,
      rgba(255, 255, 255, 0.08) 50%,
      rgba(255, 255, 255, 0.04) 100%
    );
    background-size: 200% 100%;
    animation: ${shimmer} 1.4s ease-in-out infinite;
  }

  @media (max-width: 720px) {
    ::before {
      margin-right: 0;
      min-width: 0;
    }
  }
`;

// ============================================================
// Pager (.pager) — Anterior / 1 2 3 ... / Proximo + exibir N
// ============================================================
export const Pager = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 20px var(--cco-pad);
  border-top: 1px solid var(--cco-line);
  flex-wrap: wrap;

  @media (max-width: 480px) {
    gap: 8px;
    padding: 14px var(--cco-pad);
    .btn {
      padding: 0 12px;
      font-size: 11.5px;
    }
    .pg {
      width: 32px;
      height: 32px;
      font-size: 12.5px;
    }
  }

  .btn {
    height: 36px;
    padding: 0 18px;
    border-radius: 9px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid var(--cco-line);
    color: var(--cco-ink);
    font-size: 12.5px;
    font-weight: 600;
    letter-spacing: 0.04em;
    transition: all 150ms ease;
    cursor: pointer;
    font-family: inherit;
  }
  .btn:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.08);
  }
  .btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  .pages {
    display: flex;
    gap: 6px;
    align-items: center;
  }
  .pg {
    width: 36px;
    height: 36px;
    border-radius: 9px;
    display: grid;
    place-items: center;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid var(--cco-line);
    color: var(--cco-ink);
    font-size: 13.5px;
    font-weight: 600;
    transition: all 150ms ease;
    cursor: pointer;
    font-family: inherit;
  }
  .pg.on {
    background: var(--cco-cyan);
    border-color: var(--cco-cyan);
    color: #0a0a0b;
  }
  .pg:not(.on):hover {
    background: rgba(255, 255, 255, 0.08);
  }
  .dots {
    color: var(--cco-ink-mute);
    padding: 0 4px;
    font-weight: 700;
  }
  .exhibit {
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--cco-ink-mute);
    font-size: 12.5px;
  }
  .exhibit select {
    height: 32px;
    padding: 0 28px 0 12px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid var(--cco-line);
    color: var(--cco-ink);
    font-size: 13px;
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(255,255,255,.4)' d='M0 0h10L5 6z'/></svg>");
    background-repeat: no-repeat;
    background-position: right 8px center;
    font-family: inherit;
  }
`;

// ============================================================
// Compat exports — mantem nomes antigos pra nao quebrar imports
// em outras telas/componentes que ainda usam Card/Wrapper/etc.
// ============================================================
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const Card = styled.div`
  display: flex;
`;
export const ButtonCliente = Cta;
export const ButtonDiv = styled.div``;
export const PaginationContainer = Pager;
export const Label = styled.span`
  font-size: 12.5px;
  color: var(--cco-ink-mute);
`;
export const IconNew = styled.img``;
export const LabelCadastro = styled.span``;
